import fetch from '../../../../utils/fetch';
import * as types from './mutation_types';
import moment from 'moment';

const getItems = ({ commit }, page = 'audio') => {
  commit(types.TOGGLE_LOADING);

  fetch(page)
    .then(response => response.json())
    .then((data) => {
      data['hydra:member'].forEach(audio => {        
        audio.created = moment(audio.created).format("Y-MM-DD");        
      });                  
      commit(types.TOGGLE_LOADING);
      commit(types.SET_ITEMS, data['hydra:member']);
      commit(types.SET_VIEW, data['hydra:view']);
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_ERROR, e.message);
    });
};

export const getSortedItems = ({ commit }, options) => {
  let path;
  if (options.field && options.order && options.page) {    
    path = `audio?order[${options.field}]=${options.order}&page=${options.page}`;
  } else if (options.field && options.order) {
    path = `audio?order[${options.field}]=${options.order}`;
  } else {
    path = 'audio';
  }
  commit(types.TOGGLE_LOADING); 
  fetch(path)
    .then(response => response.json())
    .then((data) => {
      data['hydra:member'].forEach(audio => {        
        audio.created = moment(audio.created).format("Y-MM-DD");        
      });                  
      commit(types.TOGGLE_LOADING);
      commit(types.SET_ITEMS, data['hydra:member']);
      commit(types.SET_VIEW, data['hydra:view']);
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_ERROR, e.message);
    });
};

export const getSelectItems = (
  { commit },
  { page = 'audio', params = { properties: ['@id', 'name'] } } = {},
) => {
  commit(types.TOGGLE_LOADING);

  fetch(page, { params })
    .then(response => response.json())
    .then(data => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_SELECT_ITEMS, data['hydra:member']);
    })
    .catch(e => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_ERROR, e.message);
    });
};

export default getItems;



// WEBPACK FOOTER //
// ./src/store/modules/audio/list/actions.js